import React from 'react';
import { createRoot } from 'react-dom/client';
import { LicenseInfo, muiXTelemetrySettings } from '@mui/x-license';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import './util/translations';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

LicenseInfo.setLicenseKey(
  'e3f99274e9cbfccb7ab171691a5534f2Tz0xMjkzMjQsRT0xODEwNTk4Mzk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9UTEtMjAyNixRPTEsQVQ9c2luZ2xlLEtWPTI='
);

// MUI X v9 enables anonymous telemetry in development mode by default. Disable
// it explicitly — this is a PHI-adjacent healthcare app and must not emit any
// usage data to third parties, even in dev.
muiXTelemetrySettings.disableTelemetry();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false
    }
  }
});

const root = createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
  // </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
